module.exports = __webpack_public_path__ + "media/country_flags/hr-d5a5cb42.png";